import React, { useCallback, useState } from 'react'
import Section from 'components/QuestionnaireRequest/AdminNew/Tabs/Section'
import EnableQuestionnaire from 'components/QuestionnaireRequest/AdminNew/Tabs/General/Enable'
import EnableAutoArchive from 'components/QuestionnaireRequest/AdminNew/Tabs/General/EnableAutoArchive'
import EnableDisclaimer from 'components/QuestionnaireRequest/AdminNew/Tabs/General/EnableDisclaimer'
import GenericPreviews from 'components/QuestionnaireRequest/AdminNew/Tabs/General/GenericPreviews'
import LimitAcceptedFormTypes from 'components/QuestionnaireRequest/AdminNew/Tabs/General/LimitAcceptedFormTypes'
import IntakeSchedule from 'components/QuestionnaireRequest/AdminNew/Tabs/General/IntakeSchedule'
import { useDispatch, useSelector } from 'react-redux'
import {
  setDisclaimerText,
  setEnabled,
  setGenericFormPreviews,
  setIntakeSchedule,
  setIsAutoArchiveEnabled,
  setIsDisclaimerEnabled,
  setIsGenericPreviewEnabled,
  setLimitAcceptedFormTypes,
  setQuestionnaireAcceptedFormTypes,
  setQuestionnaireType,
} from 'components/QuestionnaireRequest/AdminNew/store/slice'

const Divider = () => <div style={{ height: 1, background: '#DBDBDB' }}></div>

export default function QuestionnaireAdminTabGeneral(props) {
  const dispatch = useDispatch()
  const {
    initialized,
    enabled,
    questionnaireType,
    isAutoArchiveEnabled,
    isDisclaimerEnabled,
    disclaimerText,
    isGenericPreviewEnabled,
    genericFormPreviews,
    limitAcceptedFormTypes,
    questionnaireAcceptedFormTypes,
    intakeSchedule,
  } = useSelector((state) => state.organizationQuestionnaireAdmin)

  const updateGenericFormPreviews = useCallback(
    (formPreviews) => dispatch(setGenericFormPreviews(formPreviews)),
    [dispatch]
  )

  if (!initialized) return null

  return (
    <div className="dome-d-flex dome-flex-column dome-gap30" style={{ marginTop: 30, width: 654 }}>
      <Section>
        <div className="dome-d-flex dome-flex-column dome-gap6">
          <EnableQuestionnaire
            organizationId={props.organization.id}
            enabled={enabled}
            updateEnabled={(enabled) => dispatch(setEnabled(enabled))}
            questionnaireType={questionnaireType}
            updateQuestionnaireType={(questionnaireType) => dispatch(setQuestionnaireType(questionnaireType))}
          />
          <EnableAutoArchive
            organizationId={props.organization.id}
            enabled={isAutoArchiveEnabled}
            updateEnabled={(isEnabled) => dispatch(setIsAutoArchiveEnabled(isEnabled))}
          />
          <EnableDisclaimer
            organizationId={props.organization.id}
            enabled={isDisclaimerEnabled}
            updateEnabled={(isEnabled) => dispatch(setIsDisclaimerEnabled(isEnabled))}
            disclaimerText={disclaimerText}
            updateDisclaimerText={(disclaimerText) => dispatch(setDisclaimerText(disclaimerText))}
          />
          <LimitAcceptedFormTypes
            organizationId={props.organization.id}
            isLimitAcceptedFormTypesEnabled={limitAcceptedFormTypes}
            updateLimitAcceptedFormTypes={(limit) => dispatch(setLimitAcceptedFormTypes(limit))}
            questionnaireAcceptedFormTypes={questionnaireAcceptedFormTypes}
            updateQuestionnaireAcceptedFormTypes={(formTypes) => dispatch(setQuestionnaireAcceptedFormTypes(formTypes))}
          />
        </div>
      </Section>
      <Divider />
      <Section header="generic form">
        <GenericPreviews
          organizationId={props.organization.id}
          isGenericPreviewEnabled={isGenericPreviewEnabled}
          updateIsGenericPreviewEnabled={(isEnabled) => dispatch(setIsGenericPreviewEnabled(isEnabled))}
          genericFormPreviews={genericFormPreviews}
          updateGenericFormPreviews={updateGenericFormPreviews}
        />
      </Section>
      <Divider />
      <Section header="intake schedule">
        <IntakeSchedule
          organizationId={props.organization.id}
          intakeSchedule={intakeSchedule}
          updateIntakeSchedule={(intakeSchedule) => dispatch(setIntakeSchedule(intakeSchedule))}
        />
      </Section>
    </div>
  )
}
